import { bool, object, func } from "prop-types";
import { observer } from "mobx-react";
import { useEstimateEditorStore } from "@tools";
import { PopMenu } from "@components";

import { MAX_LABEL_LENGTH } from "@utils";
import { LabelRow } from "@components/LabelEditor/components/LabelRow";
import { createLabelQuery } from "@query";
import { useParams } from "react-router-dom";
import { useAdditionalColors, useEditorWebsocket } from "@hooks";

export const LabelCreate = observer(({
  show,
  onClose,
  onCreateLabel,
  anchorEl,
}) => {
  const editorStore = useEstimateEditorStore();
  const socket = useEditorWebsocket();
  const { estimateUuid } = useParams();
  
  const { companyLabels, customLabels } = editorStore;
  
  const additionalColorProps = useAdditionalColors([...companyLabels, ...customLabels]);
  
  const handleCreateLabel = async (name, backgroundColor, fontColor) => {
    const id = await createLabelQuery(name, backgroundColor, fontColor, estimateUuid);
    const label = { id, name, backgroundColor, fontColor };
    editorStore.addCustomLabel(label);
    socket.requestEstimateLabelCreate(label);
    onCreateLabel(label);
    onClose();
  }
  
  return (
    <PopMenu
      show={show}
      anchor={anchorEl}
      id="labelCreate"
      onClickAway={onClose}
      style={{ maxWidth: 415 }}
      className="p-3"
      // clickAwayMouseEvent="onClick"
    >
      <LabelRow
        isNew noRemoval
        maxLength={MAX_LABEL_LENGTH}
        onCreate={handleCreateLabel}
        onCancel={onClose}
        { ...additionalColorProps }
      />
    </PopMenu>
  )
})

LabelCreate.propTypes = {
  anchorEl: object.isRequired,
  show: bool.isRequired,
  onClose: func.isRequired,
  onCreateLabel: func.isRequired,
}